// extracted by mini-css-extract-plugin
export default {"buttonLang":"Navbar_buttonLang__qYF+O"};